import { ChangeDetectionStrategy, Component, output, ViewEncapsulation, input } from '@angular/core';
import { ButtonType } from '../../models/button-type.type';
import { LargeButtonComponent } from '../large-button/large-button.component';
import { ColorScheme } from '../../models/color-scheme.interface';

@Component({
  selector: 'kds-large-icon-button',
  templateUrl: 'large-icon-button.component.html',
  styleUrl: 'large-icon-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LargeButtonComponent],
  encapsulation: ViewEncapsulation.None,
})
export class LargeIconButtonComponent {
  readonly iconClass = input<string>();
  readonly colorScheme = input<ColorScheme>('primary');
  readonly disabled = input<boolean>();
  readonly buttonText = input<string>();
  readonly loading = input<boolean>();
  readonly testId = input<string>();
  readonly isCritical = input<boolean>();
  readonly type = input<ButtonType>('button');
  readonly alignIconToRight = input(false);

  readonly buttonClick = output<MouseEvent>();
}
